import { Box, Button, Container, TextField } from "@mui/material";
import { signInWithRedirect } from "aws-amplify/auth";
import { FormEvent, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import useInput from "../../hooks/useInput";
import { signIn } from "../user/userSlice";

export const LegacyLoginPage = () => {
  const navigate = useNavigate();
  const user = useAppSelector((state) => state.user.user);

  useEffect(() => {
    if (user) {
      // Test-only login page: always redirect to /home, ignore stored deep links.
      navigate("/home");
    }
  }, [user, navigate]);

  const email = useInput("");
  const password = useInput("");
  const dispatch = useAppDispatch();

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    dispatch(signIn({ username: email.value, password: password.value }));
  };

  const title = "Core UI";
  const signInButtonText = "Sign in";
  const signInIdpButtonText = "Sign in using corporate IDP";

  return (
    <Container maxWidth="xs">
      <h1>{title}</h1>
      <form onSubmit={onSubmit}>
        <Box mb={2}>
          <TextField
            id="email"
            variant="outlined"
            label="email"
            autoComplete="email"
            value={email.value}
            onChange={email.onChange}
            fullWidth
            autoFocus
          />
        </Box>
        <Box mb={2}>
          <TextField
            id="password"
            variant="outlined"
            label="password"
            type="password"
            autoComplete="current-password"
            value={password.value}
            onChange={password.onChange}
            fullWidth
          />
        </Box>
        <Button
          id="sign-in"
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
        >
          {signInButtonText}
        </Button>
        <Button
          id="sign-in-idp"
          variant="contained"
          color="secondary"
          fullWidth
          onClick={() =>
            signInWithRedirect({
              provider: { custom: process.env.REACT_APP_AWS_AUTH_IDP! },
            })
          }
        >
          {signInIdpButtonText}
        </Button>
      </form>
    </Container>
  );
};

export default LegacyLoginPage;
